import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { type FunctionComponent } from 'react';

import { type App } from '../../types';

const valuePropositionStyles = css({
	display: 'flex',
	flexDirection: 'column',
	marginRight: token('space.300', '24px'),
});

const headerStyles = css({
	font: token('font.heading.xsmall'),
	color: token('color.text', '#091E42'),
});

const bodyStyles = css({
	font: token('font.body'),
	marginTop: token('space.050', '4px'),
	color: token('color.text.subtle', '#42526E'),
});

export const ValueProposition: FunctionComponent<{ app: App }> = ({ app }) => {
	return (
		<div css={valuePropositionStyles}>
			<div role="presentation" css={headerStyles}>
				{app.header}
			</div>
			<p css={bodyStyles}>{app.description}</p>
		</div>
	);
};
